module.exports = __webpack_public_path__ + "media/ppp/create_fundraising_event_button/icon-heart-fundraising-41150a57fbb327539e88fd0b4f265c17.svg";